import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.stop);
  }

  disconnect() {
    this.element.removeEventListener("click", this.stop);
  }

  stop(event) {
    event.stopPropagation();
  }
}
